//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';
import constants from '~/constants';
import BannerSwiper from '~/components/BannerSwiper';
import CategoryList from '~/components/CategoryList';
import Loading from '~/components/Loading';

export default {
  name: 'Guides',

  components: {
    BannerSwiper,
    CategoryList,
    Loading,
  },

  data() {
    return {
      CDN: process.env.CDN,
      page: 1,
      activeCategory: 0,
      initialSlide: 0, // for CategoryList initialSlide
    };
  },

  computed: {
    ...mapState(['guides', 'isLoading']),
    ...mapGetters(['guideCategoryName']),
    categories() {
      if (!this.guides) return [];
      const categories = [
        {
          id: 0,
          name: this.$i18n.t('GUIDE__CATEGORY__0'),
        },
        ...this.guides.categories,
      ];

      return categories;
    },
    queryCategory() {
      return Number(this.$route.query.active);
    },
  },

  watch: {
    queryCategory: {
      handler(val) {
        if (val >= 0) {
          this.activeCategory = val;
          this.$router.replace({ query: null });
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['getGuides']),
    async handleCategoryClick(categoryId, initialSlide) {
      const guides = await this.getGuides({
        category: categoryId,
        withTop: constants.WITHOUT_TOP,
      });

      if (guides) {
        this.activeCategory = categoryId;
        this.initialSlide = initialSlide;
      }
    },
    async handlePaginateClick() {
      await this.getGuides({
        category: this.activeCategory,
        page: this.page,
        withTop: constants.WITHOUT_TOP,
      });
    },
  },

  async validate({ store, query }) {
    const queryVerification = query.active ? Number(query.active) : true;
    let guides = null;

    if (queryVerification || queryVerification >= 0) {
      const payload =
        queryVerification >= 0 ? { category: queryVerification } : {};

      guides = await store.dispatch('getGuides', {
        payload,
      });
    }

    return (queryVerification || queryVerification >= 0) && !!guides;
  },
};
